import { TOffer } from '@/models/offers';

// The currency the client pays in, from the accepted offer's selection.
export const payingCurrencyOfOffer = (offer: TOffer): string =>
  offer.customerSelections?.paymentCurrency ||
  offer.customerSelections?.invoiceCurrency ||
  'EUR';
